<modal id="successful-internship">
	<div class="modal">
		<div class="modal__block-icon">
			<img class="modal__cross" (click)="closeModal('successful-internship');" src="assets/images/education/icons/icon__cross--white.svg" alt="">
		</div>
		<div class="modal__inner">
			<div class="modal__title">Спасибо!</div>
			<div class="modal__message">Мы обязательно поделимся с тобой новыми стажировками</div>
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('successful-internship');"></div>
</modal>
